export default __webpack_public_path__ + "static/media/logo.951098f5.png";